import { render, staticRenderFns } from "./GroupMemberSelect.vue?vue&type=template&id=24cb950a&"
import script from "./GroupMemberSelect.vue?vue&type=script&lang=js&"
export * from "./GroupMemberSelect.vue?vue&type=script&lang=js&"
import style0 from "./GroupMemberSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports